import React from "react";

import "./FloatingMessageLayout.scss";

const FloatingMessageLayout = (props: { children?: React.ReactNode }) => (
    <div data-testid="fm-layout" className="floating-message-layout-container">
        <div className="floating-message-card-container">{props.children}</div>
    </div>
);

export default FloatingMessageLayout;
